var map = {
	"./AtCoder.png": 218,
	"./CS Academy.png": 67,
	"./CodeChef.png": 152,
	"./CodeForces.png": 665,
	"./CodeForces::Gym.png": 295,
	"./HackerEarth.png": 156,
	"./HackerRank.png": 217,
	"./Kick Start.png": 291,
	"./LeetCode.png": 748,
	"./TopCoder.png": 212,
	"./Toph.png": 384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3;